import { fetchWrapper } from "../../common/ApiHelper";
const API_BASE_URL = process.env.REACT_APP_BACKEND_ROOT_DM;

export const submitFeedbackForm = (user_id, report_gen_feedback, map_layer_feedback, analytics_feedback, other_feedback) =>
  fetchWrapper(`${API_BASE_URL}/api/feedback/add_platform_feedback`, {
    method: 'POST',
    body: JSON.stringify({ user_id, report_gen_feedback, map_layer_feedback, analytics_feedback, other_feedback }),
  });
